import config from '../config.json';
import axios from '../utils/axiosInstance';
import React, { useState } from 'react';
import dayjs from 'dayjs';
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import createActivityImg from '../assets/undraw_creative_thinking_re_9k71.svg';
import url from '../url.json';

export const CreateActivityForm = ({ callback_setActivities }) => {
    const userId = localStorage.getItem('userId');
    const [loading, setLoading] = useState(false); 
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({
        title: "",
        userId: userId,
        startDate: dayjs(),
        endDate: dayjs().add(1, 'month')
    });

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        // 重置表單數據為初始值
        setData({
            title: "",
            userId: userId,
            startDate: dayjs(),
            endDate: dayjs().add(1, 'month')
        });
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setData({
            ...data,
            [e.target.name]: value
        });
    };

    const handleDateChange = (name, newDate) => {
        setData({
            ...data,
            [name]: newDate
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const jwtToken = localStorage.getItem("jwtToken");
        const headers = { Authorization: `Bearer ${jwtToken}` };
        const activityData = {
            userId: data.userId,
            title: data.title,
            startDate: data.startDate.toISOString(),
            endDate: data.endDate.toISOString()
        };
        try {
            // 建立活動
            const activityResponse = await axios.post(url.backendHost + config.createActivity, activityData, { headers });
            const newActivity = activityResponse.data;

            // 建立活動後，renew token
            const renewRes1 = await axios.get(url.backendHost + config.renewToken, { headers });
            if (renewRes1.data && renewRes1.data.jwtToken) {
                localStorage.setItem("jwtToken", renewRes1.data.jwtToken);
            }

            // 用新 token 建立小組
            const jwtToken2 = localStorage.getItem("jwtToken");
            const headers2 = { Authorization: `Bearer ${jwtToken2}` };
            const groupData = {
                groupName: "第1組",
                activityId: newActivity.id,
                numGroups: 1,
                userId: localStorage.getItem('userId'),
            };
            const groupResponse = await axios.post(url.backendHost + config.creatGroup, groupData, { headers: headers2 });

            // 建立小組後再 renew token
            const renewRes2 = await axios.get(url.backendHost + config.renewToken, { headers: headers2 });
            if (renewRes2.data && renewRes2.data.jwtToken) {
                localStorage.setItem("jwtToken", renewRes2.data.jwtToken);
            }

            // 用最新 token 加入小組
            const jwtToken3 = localStorage.getItem("jwtToken");
            const headers3 = { Authorization: `Bearer ${jwtToken3}` };
            const joinCode = groupResponse.data.groups[0].joinCode;
            const joinData = { userId: data.userId };
            await axios.put(`${url.backendHost + config.joinActivity}/${joinCode}/join`, joinData, { headers: headers3 });

            setOpen(false);
            setData({
                title: "",
                userId: userId,
                startDate: dayjs(),
                endDate: dayjs().add(1, 'month')
            });
            callback_setActivities((prev) => [...prev, newActivity]);
            alert("活動與小組建立成功");
        } catch (error) {
            console.error("建立活動或小組失敗:", error.response || error.message);
            alert("建立活動或小組失敗，請稍後再試！");
        } finally {
            setLoading(false);
        }
    };
    
    
    return (
        <div>
            <div onClick={handleClickOpen} style={{ cursor: 'pointer', color: 'black', textDecoration: 'none' }}>
                建立探究活動
            </div>
            <Dialog open={open} onClose={handleClose}>
                <div>
                    <img className='modal-image' src={createActivityImg} alt="Create Activity" />
                </div>
                <DialogTitle sx={{ color: 'black', textDecoration: 'none' }}>建立探究活動</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="title"
                        label="探究活動主題名稱"
                        type="text"
                        name='title'
                        value={data.title}
                        fullWidth
                        variant="standard"
                        onChange={handleChange}
                    />
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker', 'DatePicker']}>
                            <DatePicker
                                id="startDate"
                                label="請選擇開始日期"
                                textField={(params) => <TextField {...params} />}
                                format='YYYY-MM-DD'
                                name='startDate'
                                value={data.startDate}
                                onChange={(newDate) => handleDateChange('startDate', newDate)}
                            />
                            <DatePicker
                                id="endDate"
                                label="請選擇結束日期"
                                textField={(params) => <TextField {...params} />}
                                format='YYYY-MM-DD'
                                name='endDate'
                                value={data.endDate}
                                onChange={(newDate) => handleDateChange('endDate', newDate)}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </DialogContent>
                <DialogActions sx={{ p: 2.5, bgcolor: '#f8f9fa', borderTop: '1px solid #e0e0e0' }}>
                    <Button onClick={handleClose}>取消</Button>
                    <Button onClick={handleSubmit} variant="contained">新增</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
